import { connect } from 'react-redux'
import isEmail from 'validator/es/lib/isEmail'
import * as types from '../../actions/actionTypes'
import BulletButton from '../babu/BulletButton'
import TextField from '../babu/TextField'
import NavBar from '../common/NavBar'
import { ga4Event } from '../libs/ga4'
import useForm from '../libs/hooks/useForm'
import useGA4Pageview from '../libs/hooks/useGA4Pageview'

function ConfirmUserPage(props) {
  const { toPayment, confirmUserInfo } = props

  const { errors, inputs, onChange, submitted, onSubmit } = useForm({
    initialState: {
      firstName: '',
      lastName: '',
      email: '',
    },
    validate(data) {
      const { email } = data
      const newErrors = {}

      if (!isEmail(email)) {
        newErrors.email = '請輸入完整的電子信箱格式，需要包含 @ 與信箱地址'
      }
      return newErrors
    },
    onSuccessSubmit(data) {
      const { firstName, lastName, email } = data
      confirmUserInfo({
        contact_name: lastName + firstName,
        contact_email: email,
      })
      toPayment()
      ga4Event('slash_login_all_guest')
    },
  })

  const canSubmit =
    !(inputs.lastName.length === 0 || inputs.lastName.length > 50) &&
    !(inputs.firstName.length === 0 || inputs.firstName.length > 50) &&
    inputs.email

  useGA4Pageview('slash_login_all_guest_info')

  return (
    <>
      <NavBar />
      <div className="container mt-navbarSpacing max-w-[800px]">
        <p className="babu-text-subtitle text-text600 py-l">填寫基本資料</p>
        <form>
          <div className="flex my-l">
            <TextField
              containerClassName="mr-m flex-1"
              label="姓氏"
              name="lastName"
              value={inputs.lastName.trim()}
              onChange={onChange}
            />
            <TextField
              containerClassName="flex-1"
              label="名字"
              name="firstName"
              value={inputs.firstName.trim()}
              onChange={onChange}
            />
          </div>
          <div>
            <TextField
              type="email"
              label="Email"
              name="email"
              autoComplete="on"
              placeholder="你的電子信箱"
              value={inputs.email.trim()}
              error={submitted && errors.email ? errors.email : ''}
              onChange={onChange}
            />
            {!errors.email && (
              <p className="babu-text-fineprint mt-xxs text-text500">
                訂單明細將會寄到此信箱
              </p>
            )}
          </div>
          <BulletButton
            variant="solid"
            className="mt-m"
            type="submit"
            disabled={!canSubmit}
            onClick={onSubmit}>
            下一步
          </BulletButton>
        </form>
      </div>
    </>
  )
}

export default connect(null, dispatch => ({
  confirmUserInfo(userInfo) {
    dispatch({ type: types.CONFIRM_USER_INFO, payload: userInfo })
  },
}))(ConfirmUserPage)
